module.exports = __webpack_public_path__ + "files/c0f20e026c6165791e77ea8d05c6e9c4.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji/emojilarge.png
// module id = 306
// module chunks = 60